import { SVGUniqueID } from './svg-unique-id';
import type { IconProps } from './types';
const Icon = (props: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    width={props.size || 24}
    height={props.size || 24}
    viewBox="0 0 30 30"
    {...props}
  >
    <g clipPath="url(#clip0_4460_115416)">
      <path
        opacity={0.9}
        d="M6.38462 21.2069L-1 30H31V24L22.5 24.5L15.3516 15L6.38462 21.2069Z"
        fill="url(#paint0_linear_4460_115416)"
      />
      <path
        d="M-1 30L5.7177 21.5747L14.9939 15L22.5 24.5L31 24.1315"
        stroke="#F17B74"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_4460_115416"
        x1={15}
        y1={15}
        x2={15}
        y2={29}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F17B74" />
        <stop
          offset={1}
          stopColor="#F17B74"
          stopOpacity={0}
        />
      </linearGradient>
      <clipPath id="clip0_4460_115416">
        <rect
          width={30}
          height={30}
          fill="white"
        />
      </clipPath>
    </defs>
  </svg>
);
const SvgAreaSpineColored = (props: IconProps) => (
  <SVGUniqueID>{Icon(props)}</SVGUniqueID>
);
export default SvgAreaSpineColored;
